import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { LoaderService } from '../service/loader.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { API_HEADER } from '../service/stats.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // TODO: Exlude some requests from loader
    if (
      req.headers.get(API_HEADER.HEADER_NAME) !== API_HEADER.HEADER_GET_PRICE &&
      req.headers.get(API_HEADER.HEADER_NAME) !==
        API_HEADER.HEADER_POST_PRICE &&
      req.headers.get(API_HEADER.HEADER_NAME) !== API_HEADER.HEADER_GET_STATS
    ) {
      this.loaderService.show();
    }

    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.loaderService.hide();
          }
        },
        error: () => {
          this.loaderService.hide();
        },
      })
    );
  }
}
